import { useState } from 'react'
import { AppButton } from '@/shared/ui/button'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken, insertUserSettingsFx } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { goToMain } from '@/app/routing/events'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { AnimatePresence, motion } from 'framer-motion'

export const OnboardingPage = () => {
  useHideNav()
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const btnTexts = lang[userLang].pages.btnTexts
  const texts = lang[userLang].pages.main
  const [currentStep, setCurrentStep] = useState(0)

  const backgrounds = [
    '/assets/backgrounds/onboarding1.webp',
    Math.random() > 0.5 ? '/assets/backgrounds/onboarding2-1.webp' : '/assets/backgrounds/onboarding2-2.webp',
    Math.random() > 0.5 ? '/assets/backgrounds/onboarding3-1.webp' : '/assets/backgrounds/onboarding3-2.webp',
  ]

  const titles = [texts.monetize, texts.earn, texts.receive]

  const handleNext = () => {
    if (currentStep >= 2) {
      goToMain()
      insertUserSettingsFx({
        token: userToken!,
        data: {
          key: 'isOnboarded',
          value: true,
        },
      })
      return
    }
    setCurrentStep((prev) => prev + 1)
  }

  return (
    <div className={classes.root}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentStep}
          className={classes.background}
          style={{ backgroundImage: `url(${backgrounds[currentStep]})` }}
          initial={{ opacity: 0, scale: 1.02 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.98 }}
          transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
        />
      </AnimatePresence>

      <div className={classes.overlayTop} />
      <div className={classes.overlayBottom} />

      <AnimatePresence mode="wait">
        <motion.span
          key={currentStep}
          className={classes.heading}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          style={{
            top: currentStep === 0 ? 'unset' : '84px',
            bottom: currentStep === 0 ? '144px' : 'unset',
            textShadow: '0px 0px 10px rgba(0, 0, 0, 0.9)',
          }}
        >
          {titles[currentStep]}
        </motion.span>
      </AnimatePresence>

      <div className={classes.buttonContainer}>
        <AppButton
          className={classes.button}
          onClick={handleNext}
        >
          {currentStep < 2 ? btnTexts.next : btnTexts.time}
        </AppButton>
        <div className={classes.dotsContainer}>
          {[0, 1, 2].map((step) => (
            <div
              key={step}
              className={`${classes.dot} ${
                currentStep === step
                  ? classes.activeDot
                  : step < currentStep
                  ? classes.completedDot
                  : classes.inactiveDot
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
